import { useMemo } from 'react';
import axios, { CancelToken, CancelTokenSource } from 'axios';
import uuid from 'uuid/v4';

export interface IReturnInterface {
    remove(): boolean,
    ['new'](): CancelToken,
    get(): CancelTokenSource | void
}

class RequestCancelToken {

    private tokens: Map<string, CancelTokenSource> = new Map();

    create = (key?: string) => {
        if(!key) {
            // tslint:disable-next-line no-parameter-reassignment
            key = uuid();
        }

        if(this.tokens.has(key)) {
            console.warn('Cancel token is `%s` duplicate!', key);
        }

        this.tokens.set(key, axios.CancelToken.source());

        return {
            remove: this.remove.bind(this, key),
            new   : this.new.bind(this, key),
            get   : this.get.bind(this, key)
        };
    };

    private remove(key: string): boolean {
        const token = this.tokens.get(key);

        if(token) {
            token.cancel(`Token '${key}' canceled`);

            this.tokens.delete(key);
        }

        return true;
    }

    private new(key: string): CancelToken {
        const token = this.tokens.get(key);
        const result = axios.CancelToken.source();

        if(token) {
            this.remove(key);
        }

        this.tokens.set(key, result);

        return result.token;
    }

    private get(key: string): CancelTokenSource | void {
        return this.tokens.get(key);
    }
}

const requestCancelToken = new RequestCancelToken();

export const useCancelToken = () => useMemo(requestCancelToken.create, []);

export const useCancelTokens = (count = 1) => useMemo(() => {
    const result = [];

    for(let i = 0; i < count; i++) {
        result.push(requestCancelToken.create());
    }

    return result;
}, []);

export default requestCancelToken;
